<template>
  <ankh-list :showPager="false">
    <template #btn-group>
      <el-button @click="handleSaveSubmit">{{$t('保存更改')}}</el-button>
      <el-button @click.native="$refs.treeTable.handleChangeExpandState()">{{expandState ? $t('收起') : $t('展开')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('类型名称')">
        <el-input :placeholder="$t('类型名称')" v-model="searchForm.name" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="resetEmpty()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <tree-table
          ref="treeTable"
          :height="height"
          :column-list="columnList"
          :data="tableData"
          :row-template="rowTemplate"
          :expand.sync="expandState">
        <template #name="{row}">
          <div>
            <div v-if="row.isFirstRow" class="parent-input">
              <el-input v-model="row.name" style="flex: 1" />
              <el-link :underline="false" type="primary" @click="$refs.treeTable.handleAddRow(row)">+ {{$t('添加子分类')}}</el-link>
            </div>
            <el-select v-model="row.typeCode" v-else>
              <el-option :value="item.code" :label="item.name" v-for="item in categoryList" :key="item.id" />
            </el-select>
          </div>
        </template>


        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
          </div>
        </template>
      </tree-table>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";
import AnkhList from "@/components/list/AnkhList.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {resetEmpty} from "@/utils/common";

export default {
  name: "SearchType",
  components: {TreeTable, AnkhList},
  data() {
    return {
      searchForm: {},
      tableData: [],

      columnList: [
        {label: "类型名称", prop: "name", type: "input", minWidth: "400", fixed: "left"},
        {label: "默认展开", prop: "expand", type: "switch", minWidth: "100"},
        {label: "创建时间", prop: "createTimeStr", minWidth: "200"},
        {label: "操作", prop: "operate", minWidth: "100"},
      ],

      // 新增row 需要的字段数据
      rowTemplate: {
        name: "",
        expand: "yes",
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss")
      },

      expandState: true,

      categoryList: [],
    }
  },
  mounted() {
    this.getRecipeCategoryList();
    this.handleSearch();
  },
  methods: {
    resetEmpty,
    // 提交
    async handleSaveSubmit() {
      try {
        const params = this.handleBuildParams(this.tableData);
        console.log("params", params);
        await request(this.$api.searchTypeSort.save, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      }catch(e) {
        console.log(e);
      }
    },

    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if(item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          code: item.isNewAdd ? null : item.code,
          sort: index + 1,
          expand: item.expand,
          type: item.type,
          typeCode: item.typeCode,
          sub
        }
      })
    },

    // 菜谱类目列表
    async getRecipeCategoryList() {
      try {
        const res = await request(this.$api.cookbookSort.list, {onPage: false});
        this.categoryList = res.cookbookSorts;
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.searchTypeSort.delete, {code: row.code});
        }
        this.tableData = handleDeleteTreeNode([row.code], this.tableData);
        this.$message.success(this.$t('操作成功'));

      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      const selected = this.$refs.treeTable.handleGetSelected();
      if (!selected.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
          await handleDeleteTip();
          let codes = selected.filter(f => !f.isNewAdd).map(item => item.code);
          if (codes.length) {
            await request(
                this.$api.searchTypeSort.batchDelete,
                codes,
                {isJson: true},
            );
          }
          const delCodes = selected.map(item => item.code);
          this.$message.success(this.$t('操作成功'));
          this.tableData = handleDeleteTreeNode(delCodes, this.tableData);
      } catch (e) {
        console.error(e);
      }
    },

    // 搜索数据
    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
        }
        let res = await request(this.$api.searchTypeSort.list, params);
        this.tableData = handleBuildTreeData(res.searchTypeSorts, (item) => {
          return {
            createTimeStr: this.$moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
          }
        })

        this.handleRemoveThird();
      } catch (e) {
        console.error(e);
      }
    },

    // 去掉三级
    handleRemoveThird() {
      this.tableData = this.tableData.map(item => {
        item.sub = item.sub.map(s => {
          s.sub = [];
          return s;
        })
        return item;
      })
    }
  },
}
</script>

<style scoped>

/deep/ .cell {
  display: flex;
  align-items: center;
}

.parent-input {
  display: flex;
  align-items: center;
  column-gap: 10px;
}

</style>
